import { getSearchParam } from "@tastyworks/shared-browser-utils/url"

// Runtime cookie-auth toggle, set once per load by the root layout.
//
// When enabled, the session lives in an HttpOnly cookie set by the backend at
// login instead of a bearer token in sessionStorage, and every request carries
// the CSRF header (see the cookie-csrf transport in @tastyworks/tastyworks-api).
let runtimeEnabled = false

export function setCookieAuthEnabled(enabled: boolean): void {
  runtimeEnabled = enabled
}

export function isCookieAuthEnabled(): boolean {
  return runtimeEnabled
}

export function getCookieAuthOverride(): boolean | null {
  if (typeof localStorage === "undefined") {
    return null
  }
  const override = localStorage.getItem("use_cookie_auth")
  if (override === "true") {
    return true
  }
  return override === "false" ? false : null
}

export function isCookieModeRequested(): boolean {
  return getSearchParam("auth-mode", window.location) === "cookie"
}
